module.exports = __webpack_public_path__ + "static/media/about-quran-pic.48efd023.png";